import {
  PhoneContentDisplayEnum,
  type PhoneContent as PhoneContentType,
} from '../../../../../shared/types'
import usePhoneContent from './usePhoneContent'
import styles from './PhoneContent.module.scss'
import Directory from './Directory/Directory'
import Telephone from './Telephone/Telephone'
import { parentMeta } from '../../type'

interface PhoneContentProps {
  parentMeta?: parentMeta
  content: PhoneContentType
  filePath?: string
}

const PhoneContent = (props: PhoneContentProps) => {
  const { content } = props
  const {} = usePhoneContent()

  return (
    <div className={styles.phoneContentRoot}>
      {content?.display?.includes(PhoneContentDisplayEnum.Directory) && (
        <Directory />
      )}
      {content?.display?.includes(PhoneContentDisplayEnum.Telephone) && (
        <Telephone />
      )}
    </div>
  )
}

export default PhoneContent
